import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { Toaster } from '../ui';
import { useAppStore } from '../../stores/appStore';
import { isPartnerReadOnlyMode } from '../../lib/readOnlyMode';

export function Layout() {
  const { tenant } = useAppStore();
  const isTrial = tenant?.status === 'trial';
  const isReadOnlyMode = isPartnerReadOnlyMode();
  const trialDaysLeft = tenant?.trialEndsAt 
    ? Math.ceil((new Date(tenant.trialEndsAt).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
    : 0;

  return (
    <div className="flex h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100">
      <Toaster />
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        
        {isTrial && (
          <div className="bg-blue-600 text-white px-6 py-2 flex justify-center items-center">
            <span className="text-sm font-medium">
              Você está usando a versão de avaliação. Restam {trialDaysLeft} dias.
            </span>
          </div>
        )}

        {isReadOnlyMode && (
          <div className="bg-amber-500 text-amber-950 px-6 py-2 flex justify-center items-center">
            <span className="text-sm font-medium">
              Modo leitura ativo: você está no tenant do cliente e não pode alterar dados.
            </span>
          </div>
        )}

        <main className="flex-1 overflow-auto p-6 bg-slate-50 dark:bg-slate-950">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
